import { render, staticRenderFns } from "./admin-multidemo-reset-dialog.vue?vue&type=template&id=32cb865d&scoped=true&"
import script from "./admin-multidemo-reset-dialog.vue?vue&type=script&lang=js&"
export * from "./admin-multidemo-reset-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cb865d",
  null
  
)

export default component.exports